// ANCHOR Date FNS
import { addSeconds, intervalToDuration } from 'date-fns';
import { formatCountLabel } from './formatCountLabel';

export const formatDateDuration = (periodInSeconds: number) => {
  const {
    years,
    months,
    weeks,
    days,
    hours,
    minutes,
    seconds,
  } = intervalToDuration({
    start: new Date(),
    end: addSeconds(new Date(), periodInSeconds),
  });

  const yearsLabel = !years ? '' : formatCountLabel(years, 'year');
  const monthsLabel = !months ? '' : formatCountLabel(months, 'month');
  const weeksLabel = !weeks ? '' : formatCountLabel(weeks, 'week');
  const daysLabel = !days ? '' : formatCountLabel(days, 'day');
  const hoursLabel = !hours ? '' : formatCountLabel(hours, 'hour');
  const minutesLabel = !minutes ? '' : formatCountLabel(minutes, 'minute');
  const secondsLabel = !seconds ? '' : formatCountLabel(seconds, 'second');

  const labels = [
    yearsLabel,
    monthsLabel,
    weeksLabel,
    daysLabel,
    hoursLabel,
    minutesLabel,
    secondsLabel,
  ];

  return labels.filter(Boolean).join(' ');
};
